export enum SeriesCompareOptionsEnum {
    individual,
    tagsWithinTagGroup,
    socialTopicsWithinTheme
}
